import React from "react";

type Props = {
    balance?: number;
    payOpen: boolean;
    onTogglePay: () => void;
};

function OutstandingCard({ balance = 0, payOpen, onTogglePay }: Props) {
    const isZero = balance === 0;
    const isAdvance = balance < 0;

    const displayAmount = Math.abs(balance).toFixed(2);

    return (
        <div className="bg-white border border-slate-200 rounded-xl p-4 flex flex-col gap-2 w-auto shrink-0 self-start shadow-md h-full">
            {/* Dynamic Label */}
            <p className="text-[11px] text-slate-400 uppercase tracking-widest">
                {isAdvance ? "Advance Balance" : "Outstanding Balance"}
            </p>
            <div className="w-full h-full flex justify-items-center text-center">
                {/* Amount */}
                <p
                    className={[
                        "text-4xl font-bold tracking-tight",
                        isAdvance ? "text-green-600" : "text-red-600",
                    ].join(" ")}
                >
                    {displayAmount} QR
                </p>
            </div>



        </div>
    );
}

export default OutstandingCard;